import ProductFiltering from 'modules/productFiltering';
import compareBar from 'modules/compareBar';
import ProductPreselect from 'modules/productPreselect';
import ProductLazyLoad from 'modules/productLazyLoad';
import FilterCarousel from 'modules/filterCarousel';

export default {
	init() {
		ProductFiltering.init();
		compareBar.init($('.js-compare-bar'), $('.js-compare-checkbox'));
		ProductPreselect.init($('.js-filter-results'));
		ProductLazyLoad.init();
		FilterCarousel.init($('.js-filter-carousel'));
	},
};
